import { environment } from 'src/environments/environment';

export interface AbleProConfig {
  layout: string;// vertical, horizontal, compact
  isDarkMode: string; // light, dark, auto-mode
  theme_color: string; // blue-theme, indigo-theme, purple-theme, pink-theme, red-theme, orange-theme, yellow-theme, green-theme, teal-theme, cyan-theme
  isRtlLayout: boolean; // false true
  isBox_container: boolean; // false true
  theme_contrast: boolean;//true false
  menu_caption: boolean;// true false
}

export function getConfig(): AbleProConfig {
  return {
    layout: environment.themeconfig?.layout || 'vertical',
    isDarkMode: environment.themeconfig?.isDarkMode || 'light',
    theme_color: environment.themeconfig?.theme_color || 'blue-theme',
    isRtlLayout: environment.themeconfig?.isRtlLayout || false,
    isBox_container: environment.themeconfig?.isBox_container || false,
    theme_contrast: environment.themeconfig?.theme_contrast || false,
    menu_caption: environment.themeconfig?.menu_caption || false
  };
}